import e from "./ExternalDocs.vue_vue_type_script_setup_true_lang.js";
//#region src/shared/ExternalDocs.vue
var t = e;
//#endregion
export { t as default };

//# sourceMappingURL=ExternalDocs.vue.js.map